<!-- routify:options param-is-page=true -->
<script lang="ts">
  import StorefrontView from "@retailer/svelte/Storefront/StorefrontView.svelte";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import DistributorsStore from "@shared/svelte/Stores/DistributorsStore";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { params } from "@roxi/routify";
  import * as _ from "lodash";

  const storefrontRes = async () => {
    let res = await HttpPromise({
      method: "GET",
      url: "/api/retailer/storefronts/",
      data: $params,
    });
    return res;
  };

  const distributorsRes = async () => {
    let res = [];
    res = await HttpPromise({
      method: "GET",
      url: "/api/retailer/distributors",
      data: {
        with_cutoff_time: true,
        with_integrated: true,
        with_sales_reps: true,
        with_domains: true,
      },
    }).catch(() => (res = []));
    DistributorsStore.set(res);
    return res;
  };

  const load = async () => {
    const promises = [distributorsRes(), storefrontRes()];

    let results = await Promise.all(promises);
    return {
      distributors: results[0],
      storefront: results[1],
    };
  };

</script>

{#await load()}
  <Spinner />
{:then data}
  <StorefrontView storefront={data.storefront} />
{:catch error}
  <div>We had an error loading this storefront - please refresh.</div>
{/await}
